<mat-toolbar oneTopbar class="cn-edit-flow-top-bar">
    <mat-toolbar-row>
        <button (click)="cancelNotificationProcess()" class="one-topbar-close-button" mat-icon-button one-icon-button>
        <mat-icon>close</mat-icon>
        </button>
        <span one-topbar-title>Create local notification {{localNotificationId}}</span>
    </mat-toolbar-row>
</mat-toolbar>